<template>
    <el-dialog :title="title" :visible="dialogFormVisible" :before-close="handleClose" :closeOnClickModal="false">
        <el-form :label-width="labelwidth" ref="model" :model="model" :rules="rules" :label-position="labelPosition">
            <el-form-item label="标签号" prop="LabelNo">
                <el-input size="small" v-model="model.LabelNo" auto-complete="off" placeholder="请输入标签号" maxlength="100">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateLableDetail,
    } from '../../../api/tag'
    export default {
        data() {
            return {
                title: '编辑标签',
                name: 'edit',
                labelwidth: '80px',
                labelPosition: 'right',
                model: {
                    LabelNo: null,
                    LableDetailOID: null
                },
                rules: {
                    LabelNo: [{
                        required: true,
                        message: '请输入标签号',
                        trigger: 'blur'
                    }],
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            LabelNo: {
                required: true,
            },
            LableDetailOID: {
                required: true
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.model.LabelNo = this.LabelNo;
                this.model.LableDetailOID = this.LableDetailOID;
            },
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        this.UpdateLableDetail()
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'error'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateLableDetail() {
                UpdateLableDetail(this.model).then(data => {
                    if (!data.iserror) {
                        this.$message({
                            message: '编辑成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
        }
    }
</script>

<style>

</style>